module.exports = __webpack_public_path__ + "img/signout_icon.1535a7b7.svg";